<div class="row">
    <app-feed class="wall col-12 mb-2"></app-feed>

    <div class="wall fs col-12 mb-2 mt-4 ml-2">
        <strong class="home-title">{{ 'home.pages.home.collaborativeIntelligence' | translate }}</strong>
    </div>

    <div class="wall fs col-12 col-sm-6">
        <div class="d-flex">
            <select
                *ngIf="scoopItTopics && scoopItTopics.length > 0"
                (ngModelChange)="ngModelChange($event)"
                [(ngModel)]="idTopicSelected"
                name="topicId"
                id="topic"
                formcontrolname="topicId"
                required=""
                class="form-control ng-pristine ng-valid ng-touched"
                ng-reflect-required=""
                ng-reflect-name="topicId"
            >
                <option *ngFor="let topic of scoopItTopics" value="{{ topic.idTopic }}" class="ng-star-inserted">
                    {{ topic.nameTopic }}
                </option>
            </select>
            <a
                *ngIf="topicSelected && (currentUser.userType.id === '2' || isUserCommunityInfluencer(topicSelected.idCommunautes))"
                target="_blank"
                pButton
                class="ml-2"
                [href]="urlScoopItAdmin + '/topic/' + topicSelected.endpointTopic"
                rel="noopener noreferrer"
            >
                <em class="icon icon-edit d-md-none"></em><span class="d-none d-md-inline">{{ 'components.button.buttonGestion' | translate }}</span>
            </a>
        </div>
    </div>
    <div class="col-sm"></div>
    <app-wall *ngFor="let topic of scoopItTopics" [visible]="topic.idTopic == idTopicSelected ? true : false" [idTopic]="topic.idTopic"></app-wall>
</div>
